"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferStepPreview = OfferStepPreview;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_intl_1 = require("react-intl");
const offer_context_1 = require("@src/components/pages/admin/modules/offer-create-or-edit/offer-context");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const OfferDetails_1 = require("@src/components/modules/global/OfferDetail/OfferDetails");
const offer_model_1 = require("@src/components/pages/admin/modules/offer-create-or-edit/offer-model");
const use_offer_api_1 = require("@src/components/pages/admin/modules/offer-create-or-edit/use-offer-api");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const CreditSummary_1 = require("./CreditSummary");
const OfferStepPreviewSubmitArea_1 = require("./OfferStepPreviewSubmitArea");
const offer_promotion_context_1 = require("../../../offers/offer-promotion-context");
function OfferStepPreview({ goToPreviousStep, goToPreviousStepButtonText }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_1.useHistory)();
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const offerAction = (0, offer_context_1.useOfferContextValueSelector)(v => v.offerAction);
    const offerBasicInfo = (0, offer_context_1.useOfferContextValueSelector)(v => v.offer.basicInfo.values);
    const offerAssets = (0, offer_context_1.useOfferContextValueSelector)(v => v.offer.assets.values);
    const offerPaymentType = (0, offer_context_1.useOfferContextValueSelector)(v => v.offer.paymentType.values);
    const isEditingDuplicateOffer = (0, offer_context_1.useOfferContextValueSelector)(v => v.isEditingDuplicateOffer);
    const offerId = (0, offer_context_1.useOfferContextValueSelector)(v => v.offerId);
    const deadline = (0, offer_context_1.useOfferContextValueSelector)(v => v.offer.basicInfo.values.deadline);
    const shouldSaveDraftOnUnmountRef = (0, offer_context_1.useOfferContextValueSelector)(v => v.drafting.shouldSaveDraftOnUnmountRef);
    const { companyPremiumSettings } = (0, admin_context_1.useAdminContextValue)();
    const isPublishingOffer = offerAction === types_1.OfferAction.create || isEditingDuplicateOffer;
    const { setPromotingOffer, setIsPromotedAutomatically } = (0, offer_promotion_context_1.useOfferPromotionContextValue)();
    function redirectToAdmin({ wasOfferPublished, publishedOfferId, }) {
        if (wasOfferPublished) {
            setPromotingOffer({ id: publishedOfferId, deadline });
            if (!companyPremiumSettings.hasAutomaticOfferPromotion) {
                setIsPromotedAutomatically(false);
            }
            else {
                setIsPromotedAutomatically(true);
            }
        }
        history.pushLocalized('/admin');
    }
    const { updateOffer, createOffer } = (0, use_offer_api_1.useOfferApi)(setIsLoading);
    const submitCreateOffer = async () => {
        if (offerId) {
            const isOfferUpdated = await updateOffer({
                offerId,
                isBeingPublished: true,
                offerBasicInfo,
                offerAssets,
                isDraft: false,
                isActive: true,
                isHiringProcessActive: true,
                shouldSaveDraftOnUnmountRef,
                offerPaymentType,
            });
            if (isOfferUpdated) {
                redirectToAdmin({ wasOfferPublished: true, publishedOfferId: offerId });
            }
        }
        else {
            const publishedOfferId = await createOffer({
                offerBasicInfo,
                offerAssets,
                isActive: true,
                isDraft: false,
                isHiringProcessActive: true,
                shouldSaveDraftOnUnmountRef,
                offerPaymentType,
            });
            if (publishedOfferId) {
                redirectToAdmin({ wasOfferPublished: true, publishedOfferId });
            }
        }
    };
    const submitEditOffer = async () => {
        if (isEditingDuplicateOffer) {
            const publishedOfferId = await createOffer({ offerBasicInfo, offerAssets, offerPaymentType });
            if (publishedOfferId) {
                redirectToAdmin({ wasOfferPublished: true, publishedOfferId });
            }
        }
        else {
            updateOffer({ offerId, offerBasicInfo, offerAssets, offerPaymentType });
            redirectToAdmin({ wasOfferPublished: false });
        }
    };
    const handleSubmitButtonClick = async () => {
        if (offerAction === types_1.OfferAction.create) {
            await submitCreateOffer();
        }
        if (offerAction === types_1.OfferAction.edit) {
            await submitEditOffer();
        }
    };
    const saveButtonText = isPublishingOffer
        ? intl.formatMessage({ id: 'admin.offer_form.publish' })
        : intl.formatMessage({ id: 'admin.offer_form.save_changes' });
    const showCreditsSummary = (offerAction === types_1.OfferAction.create || isEditingDuplicateOffer) &&
        !companyPremiumSettings.hasFreeOfferPublishingEnabled &&
        offerPaymentType.paymentType === types_1.OfferPaymentType.PAY_WITH_OFFER_CREDITS;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(offerAction === types_1.OfferAction.create || isEditingDuplicateOffer) && ((0, jsx_runtime_1.jsx)("div", { className: "m-b-l", children: (0, jsx_runtime_1.jsx)(elements_1.Alert, { showIcon: true, type: "warning", message: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.warning" }), description: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.preview_alert_description" }) }) })), (0, jsx_runtime_1.jsx)(OfferDetails_1.OfferDetails, { offer: {
                    isActive: true,
                    offerTypeId: offerBasicInfo[types_1.EOfferBasicInfoFormField.offerTypeId] || null,
                    durationMin: (_a = offerBasicInfo[types_1.EOfferBasicInfoFormField.durationMin]) !== null && _a !== void 0 ? _a : null,
                    durationMax: (_b = offerBasicInfo[types_1.EOfferBasicInfoFormField.durationMax]) !== null && _b !== void 0 ? _b : null,
                    durationType: offerBasicInfo[types_1.EOfferBasicInfoFormField.durationType] || null,
                    isHomeOffice: (_c = offerBasicInfo[types_1.EOfferBasicInfoFormField.homeOffice]) !== null && _c !== void 0 ? _c : false,
                    title: offerBasicInfo[types_1.EOfferBasicInfoFormField.title] || null,
                    description: offerBasicInfo[types_1.EOfferBasicInfoFormField.description] || null,
                    deadline: offerBasicInfo[types_1.EOfferBasicInfoFormField.deadline] || null,
                    contractTypeId: offerBasicInfo[types_1.EOfferBasicInfoFormField.contractTypeId] || null,
                    formattedAddress: ((_d = offerBasicInfo[types_1.EOfferBasicInfoFormField.address]) === null || _d === void 0 ? void 0 : _d.formatted_address) || null,
                    jobAreas: offerBasicInfo[types_1.EOfferBasicInfoFormField.jobArea] || null,
                    required: (_e = offerBasicInfo[types_1.EOfferBasicInfoFormField.required]) !== null && _e !== void 0 ? _e : null,
                    niceToHave: offerBasicInfo[types_1.EOfferBasicInfoFormField.niceToHave] || null,
                    benefits: offerBasicInfo[types_1.EOfferBasicInfoFormField.benefits] || null,
                    isPaid: (_f = offerBasicInfo[types_1.EOfferBasicInfoFormField.isPaid]) !== null && _f !== void 0 ? _f : false,
                    salaryRate: offerBasicInfo[types_1.EOfferBasicInfoFormField.salaryRate] || null,
                    salaryAmountFrom: (_g = offerBasicInfo[types_1.EOfferBasicInfoFormField.salaryAmountFrom]) !== null && _g !== void 0 ? _g : null,
                    salaryAmountTo: (_h = offerBasicInfo[types_1.EOfferBasicInfoFormField.salaryAmountTo]) !== null && _h !== void 0 ? _h : null,
                    salaryCurrency: offerBasicInfo[types_1.EOfferBasicInfoFormField.salaryCurrency] || null,
                    salaryDescription: offerBasicInfo[types_1.EOfferBasicInfoFormField.salaryDescription] || null,
                    turnUpDate: (_j = (0, offer_model_1.getFormTurnUpDate)(offerBasicInfo)) === null || _j === void 0 ? void 0 : _j.toISOString(),
                    createdAt: new Date().toISOString(),
                    contactEmail: offerBasicInfo[types_1.EOfferBasicInfoFormField.contact_email] || null,
                    workingTime: {
                        timeFrom: (0, offer_model_1.transformWorkingTimeDateToClientTimezone)(offerBasicInfo[types_1.EOfferBasicInfoFormField.timezone], offerBasicInfo[types_1.EOfferBasicInfoFormField.workingTimeFrom]),
                        timeTo: (0, offer_model_1.transformWorkingTimeDateToClientTimezone)(offerBasicInfo[types_1.EOfferBasicInfoFormField.timezone], offerBasicInfo[types_1.EOfferBasicInfoFormField.workingTimeTo]),
                        timeGrant: offerBasicInfo[types_1.EOfferBasicInfoFormField.workingTimeHours] || null,
                        timeType: offerBasicInfo[types_1.EOfferBasicInfoFormField.workingTimeType] || null,
                        additionalInformation: offerBasicInfo[types_1.EOfferBasicInfoFormField.workingTimeInfo] || null,
                    },
                    skillTags: offerBasicInfo[types_1.EOfferBasicInfoFormField.skillTags],
                    skillTagsRates: offerBasicInfo[types_1.EOfferBasicInfoFormField.skillTagsRates],
                    areSkillsRated: offerBasicInfo[types_1.EOfferBasicInfoFormField.rateSkillTagsSwitch],
                    driverLicences: offerBasicInfo[types_1.EOfferBasicInfoFormField.driverLicences],
                    languages: offerBasicInfo[types_1.EOfferBasicInfoFormField.languages],
                    timezone: offerBasicInfo[types_1.EOfferBasicInfoFormField.timezone],
                    galleries: offerAssets[types_1.EOfferAssetsFormField.galleries],
                    isIndefinite: (0, offer_model_1.getIsIndefiniteStatus)(offerBasicInfo[types_1.EOfferBasicInfoFormField.isIndefinite] || null),
                    salaryType: offerBasicInfo[types_1.EOfferBasicInfoFormField.salaryType] || null,
                }, showOfferCta: false }), showCreditsSummary && (0, jsx_runtime_1.jsx)(CreditSummary_1.CreditSummary, { deadline: offerBasicInfo[types_1.EOfferBasicInfoFormField.deadline] }), (0, jsx_runtime_1.jsx)(OfferStepPreviewSubmitArea_1.OfferStepPreviewSubmitArea, { isLoading: isLoading, handleSubmitButtonClick: handleSubmitButtonClick, goToPreviousStep: goToPreviousStep, goToPreviousStepButtonText: goToPreviousStepButtonText, saveButtonText: saveButtonText })] }));
}
